import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Push, PushObject, PushOptions} from "@ionic-native/push";
import {Platform} from "ionic-angular";
import {Device} from "@ionic-native/device";
import {ApiErrorHandlerProvider} from "../api-error-handler/api-error-handler";

/*
  Generated class for the PushNotificationServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PushNotificationServiceProvider {
    errors: {};
    options: PushOptions;
    pushObject: PushObject;
    pushNotificationsAppName: any;
    pushNotificationsAndroidSenderID: any;

    constructor(
        private platform: Platform,
        private device: Device,
        private push: Push,
        public http: HttpClient,
        private apiErrorHandler: ApiErrorHandlerProvider) {
        this.pushNotificationsAppName = 'tuipoint-app';
        this.pushNotificationsAndroidSenderID = '1:556596342591:android:a2ac251bb36a7a1f';
    }

    pushInit() {
        return new Promise((resolve) => {
            if (!this.platform.is('cordova')) {
                console.warn('Push notifications not initialized. Cordova is not available - Run in physical device');
                return;
            }

            this.options = {
                android: {
                    senderID: this.pushNotificationsAndroidSenderID,
                    forceShow:true
                },
                ios: {
                    alert: "true",
                    badge: "true",
                    sound: "true"
                }
            };

            this.pushObject = this.push.init(this.options);

            return resolve(this.pushObject)
        });
    }

    handleEvents() {
        this.pushInit().then(() => {
            this.pushObject.on('notification')
                .subscribe((notification: any) => {

                    console.log(JSON.stringify(notification));

                    // if(notification.additionalData.coldstart === true) {
                    // this.nav.push(BookingsPage);
                    // } else if(this.platform.is("android")) {
                    //     // For some reason this event is triggered from a CLICK
                    //     // on Android, which only makes it easier to do.. Handle
                    //     // the click here.
                    //     this.nav.push(BookingsPage);
                    // }
                });

            this.pushObject.on('error')
                .subscribe(error => {
                    console.error('Error with Push plugin', JSON.stringify(error))
                });
        });
    }

    registerForPush() {
        return new Promise((resolve) => {
            this.pushInit().then(() => {
                this.pushObject.on('registration')
                    .subscribe((registration: any) => {
                        this.setDevicePushNotificationData(registration);
                        resolve(registration);
                    });
            })
        });
    }

    setDevicePushNotificationData(token) {
        let userId = localStorage.getItem('tuid');

        this.http.post(`/users/${userId}/devices/register`, {
            token: token.registrationId,
            platform: this.device.platform,
            uuid: this.device.uuid,
            type: token.registrationType,
            app_name: this.pushNotificationsAppName
        }).subscribe((response: any) => {
            console.log(response);
        }, error => {
            console.log(error);
        });

        return true;
    }

    removeDevicePushNotificationData() {
        let $this = this;
        return new Promise((resolve, reject) => {
            this.http
                .delete(`/users/devices`, {}).subscribe((response: any) => {
                resolve(response.data);
            }, error => {
                this.errors = this.apiErrorHandler.handleError(error);
                reject(error)
            })

        });
    }

}



// WEBPACK FOOTER //
// ./src/providers/push-notification-service/push-notification-service.ts